import axios from "axios";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useSertStore } from "@/stores/sertStore";
import { phoneFormatter } from "@/utils/functions";
import cookies from 'browser-cookies'
import { API_URL } from "@/utils/constans";

export const useRequestsStore = defineStore("request", () => {
	const storeSert = useSertStore();

	const isClient = typeof window !== 'undefined';	
	
	const token = ref(null);	
	const sessionToken = ref(null)
	const courtId = ref(null)
	if(isClient) {
		token.value = cookies.get('token');
		sessionToken.value = sessionStorage.getItem('sessionToken');
		courtId.value = sessionStorage.getItem('courtIdToken');
	}

	const setToken = (newToken) => {
        token.value = newToken; 
        cookies.set('token', newToken, {expires: 1}); 
    };
    const removeToken = () => {
        token.value = null; 
        cookies.erase('token');
    };

	const setSessionToken = (newToken) => {
		sessionToken.value = newToken;
		sessionStorage.setItem("sessionToken", newToken);
	};

	const loaderBtn = ref(false);
	const userData = ref({});
	const payData = ref({});	
	const responseError = ref(null);
	const responseOk = ref(null);
	const listCourts = ref([])
	const listQuipments = ref([])
	const courtData = ref({})
	const listCourtDates = computed(() => courtData.value.results)
	const isAuthenticated = computed(() => !!token.value);

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				removeToken();
				delete axios.defaults.headers.common["Authorization"];
			}
			return Promise.reject(error);
		},
	);

	const setAuthHeader = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const tokenURL = urlParams.get("token");
		if (tokenURL) {
			token.value = tokenURL;
		} else {
			token.value = cookies.get('token');
		}
		if (token.value) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	};

	const authorization = async () => {
		loaderBtn.value = true;
		const parameters = {
			phone_number: phoneFormatter(storeSert.checkedItems.phone.title),
		};
		try {
			const { data } = await axios.post(`${API_URL}/api/users/authorization`, parameters);
			setSessionToken(data.session_token);		
			responseError.value = null;
			return { success: true, data };
		} catch (error) {
			console.log("error sendAuthorization:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const authorizationConfirm = async () => {
		loaderBtn.value = true;
		const parameters = {
			code: storeSert.checkedItems.confirmationCode.title,
			session_token: sessionToken.value,
		};

		try {
			const { data } = await axios.post(`${API_URL}/api/users/authorization/confirm`, parameters);
			setToken(data.access);		
			await userInfo();	
			responseError.value = null;
			return { success: true, data };
		} catch (error) {
			console.log("error authorizationConfirm:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			storeSert.checkedItems.confirmationCode.title = "";
		} finally {
			loaderBtn.value = false;
		}
	};

	const userInfo = async () => {
		try {
			setAuthHeader();
			const { data } = await axios.get(`${API_URL}/api/users/user`);
			userData.value = data;			
		} catch (error) {
			if (error.response && error.response.status === 401) {
				console.warn("Пользователь не авторизован");
				userData.value = null;
			} else {
				console.error("Error getUserInfo", error);
				throw error;
			}
		}
	};
	const userInfoChnage = async () => {
		loaderBtn.value = true;

		const parameters = {
			email: storeSert.checkedItems.email.title || userData.value.email,
			first_name: storeSert.checkedItems.firstName.title || userData.value.first_name,
			last_name: storeSert.checkedItems.lastName.title || userData.value.last_name,
			birthday: storeSert.checkedItems.birthday.title || userData.value.birthday,
		};

		try {
			setAuthHeader();
			const { data } = await axios.put(`${API_URL}/api/users/user`, parameters);
			userData.value = data;		
			responseError.value = null;
			return { success: true, data };	
		} catch (error) {
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			console.error("Error userInfoChnage", error);
		} finally {
			loaderBtn.value = false;
		}
	};
	
	const contactPhoneNumberForFeedback = async () => {
		loaderBtn.value = true;

		const parameters = {
			phone_number: phoneFormatter(storeSert.checkedItems.phone.title),
		};
		try {
			const res = await axios.post(`${API_URL}/api/courts/contacts`, parameters);
			responseError.value = "";
			responseOk.value = true;
							
		} catch (error) {
			responseError.value = error.response?.data?.phone_number[0] || "Ошибка при отправке данных.";
			console.error("Error sendFeedback", error);
		} finally {
			loaderBtn.value = false;
		}
	};

	const getPaymentUrl = async () => {
		
		loaderBtn.value = true;

		const parameters = {
			cover: storeSert.checkedItems.imagePath.id,
			recipient_name: storeSert.checkedItems.userName.title,
			congratulation_text: storeSert.checkedItems.message.title,
			is_required_physical_certificate: storeSert.checkedItems.physicalCertificate.title,
			crm_id: storeSert.checkedItems.select.id,
		};
		try {
			setAuthHeader();
			const { data } = await axios.post(`${API_URL}/api/certificates/certificate`, parameters );
			payData.value = data;
			responseError.value = null;
			return { success: true, data };
		} catch (error) {
			console.log("error getPaymentUrl:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	}
	const getRentalInfo = async (id) => {
		try {
			setAuthHeader();
			const{ data }= await axios.get(`${API_URL}/api/certificates/certificate/${id}`);
			return data;			
		} catch (error) {
			console.log("error getRentalInfo:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			
		}
	};

	const logout = async () => {
		removeToken();
		userData.value = {};
		storeSert.updateFiles();
	};

	
	return {
		setAuthHeader,
		authorization,
		authorizationConfirm,
		logout,
		userInfo,
		userInfoChnage,
		contactPhoneNumberForFeedback,
		getPaymentUrl,
		getRentalInfo,

		isAuthenticated,
		loaderBtn,
		userData,
		responseError,
		responseOk,
		listCourts,
		listQuipments,
		courtData,
		listCourtDates,
		courtId,
		payData,

	};
});
